import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';

import 'style/layout/Buttons.css';

const MoveBuildingWallWithThickness = ({
  actionTriggeredCallback,
}: {
  actionTriggeredCallback: () => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);

  const moveBuildingWallWithThickness = () => {
    window.MoveBuildingWallWithThickness();
    actionTriggeredCallback();
  };

  return (
    <PrimaryButton
      className="button-long-text"
      onClick={moveBuildingWallWithThickness}
    >
      {t(
        `${translations.common}:Move Building Wall With Thickness`
      ).toLocaleUpperCase()}
    </PrimaryButton>
  );
};

export default MoveBuildingWallWithThickness;
